import { useSuspenseQuery, UseSuspenseQueryOptions } from "@tanstack/react-query";
import { Notification } from "@/types";
import { api, ErrorResponse } from "@/utils/api";
import { camelize } from "@/utils/api-helpers";

export const useNotification = (
  projectId: string,
  notificationId: string,
  options: Omit<UseSuspenseQueryOptions<unknown, ErrorResponse, Notification>, "queryKey"> = {}
) => {
  return useSuspenseQuery<unknown, ErrorResponse, Notification>({
    queryKey: ["projects", projectId, "notifications", notificationId],
    queryFn: async (): Promise<Notification> => {
      const response = await api.get<Notification>(
        `/projects/${projectId}/notifications/${notificationId}`
      );
      return camelize(response.data);
    },
    ...options
  });
};
